import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAtomValue } from 'jotai';
import CircularProgress from "@mui/material/CircularProgress";
import LzSApp from '@lz-app/App';
import lzSAuthAppConfigsAtom from '@lz-store/atoms/Auth/appConfigs';
import useLzFApiCall from '@lz-services/Api';
import { lzFShowSuccessMessage } from '@lz-services/Utils';
import SalesInvoiceModel from "./sales-invoice.model";
import SalesInvoiceFormComponent from './SalesInvoiceFormComponent';

const SalesInvoiceAddScreen = () => {
    const authAppConfigsState = useAtomValue(lzSAuthAppConfigsAtom);

    const [model, setModel] = useState(null);

    const lzApiCall = useLzFApiCall();
    const navigate = useNavigate();

    const initModel = () => {
        setModel(new SalesInvoiceModel({
            sales_tax_rate: +(authAppConfigsState?.misc?.current_standard_tax_rate || 0),
            further_tax_rate: +(authAppConfigsState?.misc?.current_further_tax_rate || 0),
            discount_rate: +(authAppConfigsState?.misc?.default_discount_rate || 0),
        }));
    };

    useEffect(() => {
        if (typeof authAppConfigsState?.misc !== 'undefined') {
            initModel();
        }
    }, [authAppConfigsState]);

    const handleSubmit = async () => {
        const salesInvoice = new SalesInvoiceModel(model);
        const data = await lzApiCall('sales-invoices', salesInvoice.getObject(), 'post');
        if (data) {
            lzFShowSuccessMessage('Record added successfully!');
            navigate('/content/sales-invoices/' + data + '/edit');
        }
    };
    const handleClose = () => navigate('/content/sales-invoices');
    const handleReset = () => initModel();

    return (
        <LzSApp.WrapperTemplate private screenTitle="Create Sales Invoice">

            {model ?
                <SalesInvoiceFormComponent
                    data={model}
                    onChange={setModel}
                    onSubmit={handleSubmit}
                    onClose={handleClose}
                    onReset={handleReset}
                />
                :
                <CircularProgress />
            }

        </LzSApp.WrapperTemplate>
    );

};

export default SalesInvoiceAddScreen;
